import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Theme } from '@riotgames/accounts-react-components/lib/Theme';
import { GridPage } from '@riotgames/accounts-react-components/lib/Grid/GridPage';
import { Pagination } from '@riotgames/accounts-react-components/lib/Pagination';
import AppContext from '../../AppContext';
import cx from 'classnames';
import SafeNavigation from '../ErrorHandler/SafeNavigation';
import Signup from '../../Signup';
import Debugger from '../../Debugger';

import './layout.scss';

const BASE_CLASS = 'signup-wrapper';

const Layout = ({ location }) => {
  const context = useContext(AppContext);
  const {
    actions: { stepTo },
    state: { theme, footer, contentFooter, pageTitle, step, age }
  } = context;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    if (location.pathname !== '/') {
      const backToStep = {
        component: age < 18 ? 'ParentConsents' : 'SelfAuth'
      };
      stepTo(backToStep);
    }
  }, [window.popstate]);

  return (
    <Theme value={theme}>
      <GridPage
        title={pageTitle}
        footer={footer}
        contentFooter={contentFooter}
        pagination={<Pagination index={step.page} total={step.pageCount} />}
        className={cx('app-container', BASE_CLASS)}
      >
        <Signup />
      </GridPage>
      <SafeNavigation />
      {process.env.REACT_APP_ENV === 'dev' && <Debugger />}
    </Theme>
  );
};

export default withRouter(Layout);
